import {TemplateList} from "~/libs/constants/TemplateList"
import {useUniWebTemplate} from "~/composables/useUniWebTemplate"
import {SeoConfig} from "~/config/SeoConfig"
import type SeoMeta from "~/libs/interfaces/SeoMeta"

export const useSeoWrapper = () => {
  /**
   * get default SEO config for template
   */
  const getSeoConfig = ():SeoMeta => {
    return useUniWebTemplate().getTemplateListItem() !== null ? SeoConfig[useUniWebTemplate().getTemplateListItem() as TemplateList] : {}
  }

  /**
   * set SEO meta
   * @param input
   * @param options
   */
  const setSeoMeta = (input: any = {}, options?: any) => {
    const seoConfig = getSeoConfig()
    const url = useRequestURL()

    const defaultSeoInput = {
      title: null, // Default title is handled by module NuxtSeo - this is title add
      author: seoConfig.author,
      description: seoConfig.description,
      ogImage: seoConfig.image,
      twitterCard: seoConfig.twitterCard,
      twitterDomain: url.hostname,
      twitterUrl: url.href,
      twitterTitle: seoConfig.title,
      themeColor: seoConfig.themeColor,
    }

    // merge DEFAULT with PAGE RELATED seo
    const newMeta = {
      ...defaultSeoInput,
      ...input
    }

    // SET missing Facebook, Twitter or other meta
    if (!newMeta.ogDescription && newMeta.description) {
      newMeta.ogDescription = newMeta.description
    }
    if (!newMeta.twitterDescription && newMeta.description) {
      newMeta.twitterDescription = newMeta.description
    }
    if (newMeta.title) {
      newMeta.twitterTitle = `${newMeta.twitterTitle} - ${newMeta.title}`
    }
    if (!newMeta.twitterImage && newMeta.ogImage) {
      newMeta.twitterImage = newMeta.ogImage
    }

    useSeoMeta(
      newMeta,
      options
    )
  }

  return {
    getSeoConfig,
    setSeoMeta,
  }
}


